import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { api } from "api";
import { useFetchStateHelper } from "hooks/useFetchState";

// DEPRECATED, uses old api.weather.fetchForDays instead of api.weather.fetchForDaysNew
export const useWeatherForDays = ({ fieldId, startDate, endDate }) => {
  const startDateFormatted = moment(startDate).format();
  const endDateFormatted = moment(endDate)
    .add(1, "day")
    .startOf("day")
    .format();

  const { data, ...queryResponse } = useQuery({
    enabled: !!fieldId && !!startDate && !!endDate,
    queryKey: [
      "weather",
      "default",
      fieldId,
      startDateFormatted,
      endDateFormatted,
    ],
    queryFn: () =>
      api.weather.fetchForDays(fieldId, startDateFormatted, endDateFormatted),
  });

  const { fetchState } = useFetchStateHelper(queryResponse);

  return {
    data,
    fetchState,
  };
};

export const useWeatherForWeek = ({ fieldId, week }) => {
  const startDate = week?.weekStartDate;
  const endDate = week?.weekEndDate;

  return useWeatherForDays({ fieldId, startDate, endDate });
};

export const useWeatherHistorical = ({ fieldId, startDate, endDate }) => {
  const startDateFormatted = moment(startDate).format("YYYY-MM-DD");
  const endDateFormatted = moment(endDate).format("YYYY-MM-DD");

  const { data, ...queryResponse } = useQuery({
    enabled: !!fieldId && !!startDate && !!endDate,
    queryKey: [
      "weather",
      "historical",
      fieldId,
      startDateFormatted,
      endDateFormatted,
    ],
    queryFn: () =>
      api.weather.fetchForDaysNew(
        fieldId,
        startDateFormatted,
        endDateFormatted
      ),
  });

  const { fetchState } = useFetchStateHelper(queryResponse);

  return {
    data,
    fetchState,
  };
};
